import { AlertNotification as AlertNotificationModel } from 'models/AlertNotification';
import { PageState } from 'models/PageState';

export const getSitewideAlerts = ({ alerts }: PageState): AlertNotificationModel[] =>
  alerts.sitewideAlert ? alerts.sitewideAlert : [];

export const getPaymentAlerts = ({ alerts }: PageState): AlertNotificationModel[] =>
  alerts.paymentAlert ? alerts.paymentAlert : [];

export const getCheckoutAlerts = ({ alerts }: PageState): AlertNotificationModel[] =>
  alerts.checkoutAlert ? alerts.checkoutAlert : [];

export const getSiteWideWithoutProductPageAlerts = ({
  alerts
}: PageState): AlertNotificationModel[] =>
  alerts.sitewideWithoutProductPageAlert ? alerts.sitewideWithoutProductPageAlert : [];
